import { SxProp, useDripsyTheme, useSx } from "dripsy";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from "react-native-reanimated";

interface SkeletonViewProps {
  height?: number;
  width?: number;
  shape?: "default" | "circle";
  sx?: SxProp;
}

export const SkeletonView: React.FC<SkeletonViewProps> = (props) => {
  const sx = useSx();
  const { theme } = useDripsyTheme();
  const { height, width, shape = "default" } = props;

  const opacity = useSharedValue(0.2);
  opacity.value = withRepeat(withTiming(1, { duration: 700 }), -1, true);
  const animatedSkeletonStyle = useAnimatedStyle(() => {
    return {
      opacity: opacity.value,
    };
  });

  let dimensions: Record<string, SxProp> = {
    default: {
      height: height || theme.space?.$3,
      width: width || theme.space?.$75,
    },
    circle: {
      height: width || theme.space?.$10,
      width: width || theme.space?.$10,
      borderRadius: 100,
    },
  };

  return (
    <Animated.View
      style={[
        sx(styles.container),
        sx(dimensions[shape]),
        props.sx && sx(props.sx),
        animatedSkeletonStyle,
      ]}
    />
  );
};

enum StyleName {
  container = "container",
}

const styles: Record<StyleName, SxProp> = {
  container: {
    borderRadius: 2,
    backgroundColor: "$skeleton",
  },
};
